var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumberOfPhases = function SvgNumberOfPhases(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3B3F44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#numberOfPhases_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.524 6a17.7 17.7 0 0 1 6.858-1.714c3.428 0 5.142 2.571 8.571 2.571a17.7 17.7 0 0 0 6.857-1.714l-3.428-1.714M1.524 12.858a17.7 17.7 0 0 1 6.858-1.715c3.428 0 5.142 2.572 8.571 2.572A17.7 17.7 0 0 0 23.81 12l-3.428-1.714M1.524 19.714A17.7 17.7 0 0 1 8.382 18c3.428 0 5.142 2.571 8.571 2.571a17.7 17.7 0 0 0 6.857-1.714l-3.428-1.714"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "numberOfPhases_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.667 0h24v24h-24z"
  })))));
};
export default SvgNumberOfPhases;